function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "b",
  width: 264,
  height: 112,
  rx: 8
}), React.createElement("filter", {
  id: "a",
  width: "105.3%",
  height: "112.5%",
  x: "-2.7%",
  y: "-4.5%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(4 2)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#b"
})), React.createElement("g", {
  transform: "translate(11 26)"
}, React.createElement("text", {
  fill: "#67717C",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 12,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 23.576,
  y: 12
}, "Classic")), React.createElement("text", {
  fill: "#67717C",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 12,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 0.704,
  y: 36
}, "Geometric")), React.createElement("text", {
  fill: "#67717C",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 12,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 193,
  y: 12
}, "Modern")), React.createElement("text", {
  fill: "#67717C",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 12,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 193,
  y: 36
}, "Organic")), React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#D8DBE2",
  strokeLinecap: "round",
  strokeWidth: 5,
  d: "M80 7.5h96"
}), React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#D8DBE2",
  strokeLinecap: "square",
  d: "M128.5 6v3M128.5 30v3M128.5 54v3"
}), React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#D8DBE2",
  strokeLinecap: "round",
  strokeWidth: 5,
  d: "M80 31.5h96"
}), React.createElement("circle", {
  cx: 144,
  cy: 7,
  r: 4,
  fill: "#00C1F1",
  fillRule: "nonzero"
}), React.createElement("circle", {
  cx: 96,
  cy: 31,
  r: 4,
  fill: "#00C1F1",
  fillRule: "nonzero"
}), React.createElement("text", {
  fill: "#67717C",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 12,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 13.112,
  y: 60
}, "Abstract")), React.createElement("text", {
  fill: "#67717C",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 12,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 193,
  y: 60
}, "Literal")), React.createElement("path", {
  fillRule: "nonzero",
  stroke: "#D8DBE2",
  strokeLinecap: "round",
  strokeWidth: 5,
  d: "M80 55.5h96"
}), React.createElement("circle", {
  cx: 112,
  cy: 55,
  r: 4,
  fill: "#00C1F1",
  fillRule: "nonzero"
})));

var Svg1 = function Svg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 272,
    height: 120,
    viewBox: "0 0 272 120",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1.70d3eb24.svg";
export { ForwardRef as ReactComponent };